















































































































































































import { Component, Emit, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { ButtonToggle } from '@/components/molecules/ButtonToggle'
import { InputCode } from '@/components/molecules/InputCode'
import { IButtonToggleItem } from '@/components/molecules/ButtonToggle/ButtonToggle.type'
import { IAtomSelectItem } from '@/components/atoms/AtomSelect/AtomSelect.type'
import {
  AloneSearchType,
  BibliographyClass,
  CollectionTarget,
  DisplayMethod,
  SearchTarget,
  SearchType
} from '@/types'
import { SearchCondition } from '@/pages/bibliographies/index.vue'
import { dataStore } from '@/utils/store-accessor'

export interface InputSearchOptionItem {
  displayMethod: {
    input: DisplayMethod
    errorMessage: string
  }
  searchTarget: {
    input: SearchTarget
    errorMessage: string
  }
  numberOfLimit: {
    input: 1000 | 3000 | 5000 | 9999
    errorMessage: string
  }
  searchMethodAnd: {
    input: boolean
    errorMessage: string
  }
  searchMethodSynonym: {
    input: boolean
    errorMessage: string
  }
  searchMethodAllograph: {
    input: boolean
    errorMessage: string
  }
  andSearchType: SearchType[]
  andMaterialFormat: {
    input: string
    errorMessage: string
  }
  andCollectionTarget: CollectionTarget[]
  andBibliographyClass: BibliographyClass[]
}

export const defaultInputSearchOptionItem = (): InputSearchOptionItem => ({
  displayMethod: {
    input: DisplayMethod.Simple,
    errorMessage: ''
  },
  searchTarget: {
    input: SearchTarget.Db,
    errorMessage: ''
  },
  numberOfLimit: {
    input: 1000,
    errorMessage: ''
  },
  searchMethodAnd: {
    input: true,
    errorMessage: ''
  },
  searchMethodSynonym: {
    input: true,
    errorMessage: ''
  },
  searchMethodAllograph: {
    input: true,
    errorMessage: ''
  },
  andSearchType: [],
  andMaterialFormat: {
    input: '',
    errorMessage: ''
  },
  andCollectionTarget: [],
  andBibliographyClass: []
})

const SELECT_ITEMS_OF_DISPLAY_FORMAT: IAtomSelectItem[] = [
  {
    value: DisplayMethod.Simple,
    text: '簡易一覧'
  },
  {
    value: DisplayMethod.Detail,
    text: '詳細一覧'
  }
  // 次期バージョン実装の為コメントアウト
  // {
  //   value: DisplayMethod.DetailAndImage,
  //   text: '書影あり詳細一覧'
  // }
]

const SELECT_ITEMS_OF_SEARCH_TARGET: IAtomSelectItem[] = [
  {
    value: SearchTarget.Db,
    text: 'ＤＢのみ'
  }
]

const SELECT_ITEMS_OF_NUMBER_OF_LIMIT: IAtomSelectItem[] = [
  {
    value: 1000,
    text: '1000件'
  },
  {
    value: 3000,
    text: '3000件'
  },
  {
    value: 5000,
    text: '5000件'
  },
  {
    value: 9999,
    text: '9999件'
  }
]

const SELECT_ITEMS_OF_SEARCH_METHOD_AND: IAtomSelectItem[] = [
  { value: true, text: 'ＡＮＤ' },
  { value: false, text: 'ＯＲ' }
]

const SELECT_ITEMS_OF_SEARCH_METHOD_SYNONYM: IAtomSelectItem[] = [
  { value: true, text: '同義語あり' },
  { value: false, text: '同義語なし' }
]

const SELECT_ITEMS_OF_SEARCH_METHOD_ALLOGRAPH: IAtomSelectItem[] = [
  { value: true, text: '異表記あり' },
  { value: false, text: '異表記なし' }
]

const TOGGLE_ITEMS_OF_AND_SEARCH_TYPE: IButtonToggleItem[] = [
  { value: SearchType.Book, text: '図書' },
  { value: SearchType.Magazine, text: '雑誌' },
  { value: SearchType.Av, text: 'AV' }
]

const TOGGLE_ITEMS_OF_AND_COLLECTION_TARGET: IButtonToggleItem[] = [
  { value: CollectionTarget.noCollection, text: '未所蔵' },
  { value: CollectionTarget.archive, text: '所蔵' },
  { value: CollectionTarget.selection, text: '選定' },
  { value: CollectionTarget.order, text: '発注' }
]

const TOGGLE_ITEMS_OF_AND_BIBLIOGRAPHY_CLASS: IButtonToggleItem[] = [
  { value: BibliographyClass.Real, text: 'R 物理' },
  { value: BibliographyClass.Set, text: 'S 集合' }
]

@Component({
  components: {
    InputDatePicker,
    InputCode,
    ButtonToggle
  }
})
export default class BibliographySearchOption extends ComponentVue {
  @PropSync('searchCondition', {
    type: Object
  })
  searchItem!: SearchCondition

  @Prop({
    type: Boolean,
    default: false
  })
  isSearchTargetDisabled!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  AndCollectionTargetSmall!: boolean

  get isTooliSearchTarget(): boolean {
    return (
      this.searchItem.searchOption.searchTarget.input === SearchTarget.Tooli
    )
  }

  get isAndSearch(): boolean {
    return (
      this.searchItem.searchOption.searchMethodAnd.input || this.isFreeSearch
    )
  }

  get isSearchTypeBasic(): boolean {
    return this.searchItem.searchType === 'basic'
  }

  get isSearchTypeAuthority(): boolean {
    return this.searchItem.searchType === 'authority'
  }

  get isSearchTypeContent(): boolean {
    return this.searchItem.searchType === 'content'
  }

  get existsFreeWords(): boolean {
    return this.searchItem.free.freeWords.input !== ''
  }

  get isFreeSearch(): boolean {
    return this.existsFreeWords && !this.isTooliSearchTarget
  }

  get selectItemsOfDisplayFormat(): IAtomSelectItem[] {
    return SELECT_ITEMS_OF_DISPLAY_FORMAT
  }

  get selectItemsOfSearchTarget(): IAtomSelectItem[] {
    if (dataStore.enabledTooli) {
      return [
        ...SELECT_ITEMS_OF_SEARCH_TARGET,
        {
          value: SearchTarget.Tooli,
          text: 'ＴＯＯＬｉのみ'
        }
      ]
    } else {
      return SELECT_ITEMS_OF_SEARCH_TARGET
    }
  }

  get selectItemsOfNumberOfLimit(): IAtomSelectItem[] {
    return SELECT_ITEMS_OF_NUMBER_OF_LIMIT
  }

  get selectItemsOfSearchMethodAnd(): IAtomSelectItem[] {
    return SELECT_ITEMS_OF_SEARCH_METHOD_AND
  }

  get selectItemsOfSearchMethodSynonym(): IAtomSelectItem[] {
    return SELECT_ITEMS_OF_SEARCH_METHOD_SYNONYM
  }

  get selectItemsOfSearchMethodAllograph(): IAtomSelectItem[] {
    return SELECT_ITEMS_OF_SEARCH_METHOD_ALLOGRAPH
  }

  get toggleItemsOfAndSearchType(): IButtonToggleItem[] {
    return TOGGLE_ITEMS_OF_AND_SEARCH_TYPE
  }

  get toggleItemsOfAndCollectionTarget(): IButtonToggleItem[] {
    return TOGGLE_ITEMS_OF_AND_COLLECTION_TARGET
  }

  get toggleItemsOfAndBibliographyClass(): IButtonToggleItem[] {
    return TOGGLE_ITEMS_OF_AND_BIBLIOGRAPHY_CLASS
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onInputSearchTarget(value: SearchTarget): void {
    this.resetErrorMessage(this.searchItem.searchOption.searchTarget)
    this.searchItem.searchOption.searchTarget.input = value

    // 検索対象切替時、入力欄表示切替によりラジオボタンの選択表示が無くなる状況がある為初期化処理を追加
    if (value === SearchTarget.Db) {
      this.searchItem.alone.searchType =
        AloneSearchType.NewPublicationInformationDate
    } else if (value === SearchTarget.Tooli) {
      this.searchItem.alone.searchType =
        AloneSearchType.NewPublicationInformationVolume
    }
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
